import React from 'react'
import SvgIcon from '@mui/material/SvgIcon';
export default function DotGreyIcon () {
    return (
    <SvgIcon>
<svg width="1" height="1" viewBox="0 -1 1 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="1" cy="1" r="0.5" fill="black" fillOpacity="0.2"/>
</svg></SvgIcon>)}